import React, { useEffect, useState } from "react";
import { PDFDocument } from "pdf-lib";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "pdfjs-dist/build/pdf.worker.min.mjs";

const PDFViewer = ({ docData }) => {
  const [pdfData, setPdfData] = useState(null);
  const [numPages, setNumPages] = useState(null);

  useEffect(() => {
    const loadPdf = async () => {
      try {
        // Decode the base64 string
        const decodedPdfData = atob(docData.documentData);
        const pdfBytes = new Uint8Array(decodedPdfData.length);
        for (let i = 0; i < decodedPdfData.length; i++) {
          pdfBytes[i] = decodedPdfData.charCodeAt(i);
        }

        // Create a new PDFDocument from the bytes
        const pdfDoc = await PDFDocument.load(pdfBytes);
        const pdfArrayBuffer = await pdfDoc.save();

        // Convert to a Blob and then to an Object URL
        const blob = new Blob([pdfArrayBuffer], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);
        setPdfData(url);
      } catch (error) {
        console.error("Error loading PDF", error);
      }
    };

    loadPdf();
  }, [docData.documentData]);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  console.log("docData", pdfData);

  return (
      <div>
        {docData.fileType.toLowerCase().includes("pdf") ? (
            <div>
              {pdfData ? (
                  <Document file={pdfData} onLoadSuccess={onDocumentLoadSuccess}>
                    {Array.from(new Array(numPages), (el, index) => (
                        <Page key={`page_${index + 1}`} pageNumber={index + 1} />
                    ))}
                  </Document>
              ) : (
                  <p>Loading PDF...</p>
              )}
            </div>
        ) : (
            <div>
              <img
                  className="image"
                  src={
                    docData.documentData
                        ? "data:image/" +
                        docData?.fileExtension +
                        ";base64," +
                        docData.documentData
                        : null
                  }
                  alt="Preview"
                  style={{ maxWidth: "100%", height: "100%" }}
              />
            </div>
        )}
      </div>
  );
};

export default PDFViewer;